import { Link } from "react-router-dom";
import inboxIcon from "../../assets/images/personal-inbox.png";
import forumIcon from "../../assets/images/forum.png";
import "./qna.scss";
import { type Role } from "../../types/user";
import { useUnreadInbox } from "../../api/studentApi";

const QnA = ({ role }: { role: Role }) => {
  const { data } = useUnreadInbox({ enabled: role === "student" });

  return (
    <div id="qna" className="paddingContent">
      <Link to="inbox">
        <div className="vertical center img-link">
          <img src={inboxIcon} alt="" />
          개인 공지
          {role === "student" && data && (
            <div className="unread">{data.count}</div>
          )}
        </div>
      </Link>
      <Link to="forum">
        <div className="vertical center img-link">
          <img src={forumIcon} alt="" />
          게시판
        </div>
      </Link>
    </div>
  );
};

export default QnA;
